import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import { InputEvent } from '../StageZero/types';
import { Grid } from '@mui/material';
import { SkillPointsProps } from './types';

const SkillPoints: React.FC<SkillPointsProps> = (props) => {
    const [skill, setSkill] = useState<string>(props.id);
    const [points, setPoints] = useState<number>(props.defaultValues?.[props.id] ?? 0);

    const handlePintsChange = (event: InputEvent) => {
        setPoints(Number(event.target.value));
    };

    useEffect(() => {
        if (props.defaultValues) {
            setSkill(props.id);
        }
    }, []);

    useEffect(() => {
        props.setItems(
            props.items.map((item) => {
                return item.id !== props.itemId
                    ? item
                    : { ...item, skills: item.skills ? { ...item.skills, [skill]: points } : {} };
            }),
        );
    }, [points]);

    return (
        <Grid item style={{ width: '18%', marginRight: '1rem' }}>
            <TextField
                id={`${props.id}_points`}
                defaultValue={points}
                type="number"
                label={props.data?.find((x) => x.id === skill)?.name?.[props.language]}
                variant="outlined"
                className="skill-points"
                onChange={handlePintsChange}
                fullWidth
            />
        </Grid>
    );
};

export default SkillPoints;
